import React, { FC } from 'react';
import { Markdown } from 'src/common/components/Markdown';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import { typography } from 'src/config/typography';
import { textOverflow } from 'src/common/styles/typography';
import { speakerFullName } from 'src/common/services/speaker';
import { SpeakerExcerpt } from 'src/common/models/speaker';

const Content = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  text-align: left;
`;

const SpeakerCompany = styled.div`
  color: ${colors.blue};
  font-size: 0.625rem;
  line-height: 0.875rem;

  ${textOverflow(1)}
`;

const SpeakerName = styled.div`
  color: ${colors.blue};
  font-weight: 700;

  ${textOverflow(1)}
`;

const SpeakerInfoContainer = styled.div`
  margin-top: auto;
`;

const Title = styled.div`
  color: ${colors.blue};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1rem;
  line-height: 1.375rem;
  overflow: hidden;
  padding-left: 2px;

  ${textOverflow(3)}
`;

export interface CourseCardContentProps {
  title: string;
  speaker?: SpeakerExcerpt;
}

export const CourseBundleListItemContent: FC<CourseCardContentProps> = ({ title, speaker }) => (
  <Content>
    <Title>
      <Markdown text={title} />
    </Title>

    {speaker != null && (
      <SpeakerInfoContainer>
        <SpeakerName>{speakerFullName(speaker)}</SpeakerName>
        <SpeakerCompany>{speaker.companyName}</SpeakerCompany>
      </SpeakerInfoContainer>
    )}
  </Content>
);
